var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-settings-overview"},[_c('SettingsTitleBar'),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap",attrs:{"id":"cards"}},_vm._l((_vm.cards),function(ref){
var key = ref.key;
var title = ref.title;
var viewComponent = ref.viewComponent;
return _c('b-card',{key:key,attrs:{"title":title},on:{"click":function($event){return _vm.$router.push('settings/'+key)}}},[_c(viewComponent,{tag:"component"}),_vm._v(" "),_c('i',{staticClass:"fas fa-edit",attrs:{"id":"edit-card"}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ba34ff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/settings/Overview.vue
// module id = g/q2
// module chunks = 1